function isPositiveDiagnosticScore(value) {
  if (value === null || value === undefined || value === '') return false;
  const score = Number(value);
  return Number.isFinite(score) && score > 0;
}

function hasNonEmptyObject(value) {
  return Boolean(value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length);
}

export function hasRestoredQualityResult(listing = {}) {
  return isPositiveDiagnosticScore(listing.qualityScore)
    || hasNonEmptyObject(listing.qualityDimensions);
}

export function hasRestoredComplianceResult(listing = {}) {
  return isPositiveDiagnosticScore(listing.complianceScore)
    || (Array.isArray(listing.complianceViolations) && listing.complianceViolations.length > 0);
}

/**
 * Saved-listing rows always deserialize compliance violations as an array.
 * An empty array is schema shape, not evidence that the optimization center
 * has run, so it must not change the restored workflow destination.
 */
export function hasRestoredDiagnosticResult(listing = {}) {
  return hasRestoredComplianceResult(listing)
    || hasRestoredQualityResult(listing);
}

/**
 * Restoring a Listing opens its editable draft by default. Step 04 remains
 * available after a draft is restored, and callers can request it explicitly
 * through the existing `step=4` URL contract.
 */
export function resolveRestoredListingTargetStep({
  hasContent = false,
  requestedStep,
  maxNavigableStep = 1,
} = {}) {
  const parsed = Number.parseInt(requestedStep, 10);
  const requested = Number.isFinite(parsed) && parsed >= 1 && parsed <= 4 ? parsed : null;
  const minimum = hasContent ? 3 : 1;
  const preferred = requested ?? minimum;
  const max = Math.max(1, Number(maxNavigableStep) || 1);
  return Math.min(Math.max(preferred, minimum), max);
}
